import {translations as defaultTranslation} from '../i18n'

export const translations = {
    fr: {
        documents: 'documents',
        emptyDocuments: 'aucun document disponible',
        undeclaredWorkDocuments: 'travail dissimulé',
        insuranceDocuments: 'assurances',
        specificDocuments: 'spécifique Actradis',
        otherDocuments: 'autres documents',
        validityDates: 'valide du {startDate} au {endDate}'
    }
}

export default {...defaultTranslation.fr, ...translations.fr}


// WEBPACK FOOTER //
// ./lib/actradis/i18n.js